import { render, staticRenderFns } from "./ElementsContainer.vue?vue&type=template&id=0fd13d90&scoped=true&"
import script from "./ElementsContainer.vue?vue&type=script&lang=js&"
export * from "./ElementsContainer.vue?vue&type=script&lang=js&"
import style0 from "./ElementsContainer.vue?vue&type=style&index=0&id=0fd13d90&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd13d90",
  null
  
)

export default component.exports